const DepositIcon = () => (
  <svg className="deposit-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
    <path
      fill="#00BA7C"
      d="M2 8V7c0-1.7 1.3-3 3-3h14c1.7 0 3 1.3 3 3v1H2Zm20 2v7c0 1.7-1.3 3-3 3H5c-1.7 0-3-1.3-3-3v-7h20ZM8.5 15c0-.8-.7-1.5-1.5-1.5s-1.5.7-1.5 1.5.7 1.5 1.5 1.5 1.5-.7 1.5-1.5Z"
    />
  </svg>
);

export default DepositIcon;
